const PROJECTS = [
    {
        id: '1',
        image: '/images/AKTStore.png',
        title : 'AKTStore ',
        technics: ['NextJs', 'MongoDB', ],
        description: 'An e-commerce platform developed with Next.js and MongoDB. The store showcases a comprehensive range of products, providing detailed information for each item.  It empowers marketers to seamlessly add products to the shopping cart. The system eﬃciently manages orders contributed by each marketer within the team, monitors order statuses, calculates individual marketer proﬁts, includes an upgradeability feature for each marketer, and oﬀers statistical charts illustrating the growth in customers, marketers, and sales. ',
        url: 'https://forever-website.vercel.app/',
        urlText: 'AKTStore website link',
        video: '',
        videoText: '',
    },
    {
        id: '2',
        image: '/images/SchedulerEase.png',
        title : 'SchedulerEase ',
        technics: ['ReactJs', 'LocalStorage', 'Socket.io'],
        description: 'A meeting scheduler app developed using React and Socket.io. Any user can define a meeting with possible dates and access meeting information when necessary. The application generates a code and associates this code with the relevant meeting. Any user can access meeting information via the shared code and see the most suitable times for everyone on the calendar. Any user can register to the meeting using the shared code and name and determine the most suitable time slots among possible dates. The user who creates the meeting chooses the best time for everyone by looking at calendar, Finally, the date specified for the meeting can be added to Google calendar. ',
        url: 'https://schedule-a-meeting-client.onrender.com ',
        urlText: 'SchedulerEase website link',
        video: 'https://drive.google.com/file/d/1-a4kx_rhOQcx6XZHG67CvYzCnnowd3RD/view?usp=sharing',
        videoText: 'SchedulerEase videa link',
    },
    {
        id: '3',
        image: '/images/Emlak.png',
        title : 'Emlak ',
        technics: ['ASP.Net', 'Sql Server DB', 'MVC'],
        description: 'A website created using ASP.NET with C# language and a SQL Server database. It showcases real estate and provides a comprehensive suite of services for sellers, buyers of residential properties, and tenants. The platform features an intuitive and simpliﬁed interface, enabling users to easily furnish detailed property descriptions and upload a set of pictures for each listing. Additionally, it streamlines communication between sellers and buyers. ',
        url: '',
        urlText: '',
        video: 'https://drive.google.com/file/d/1HMbNDL8qdhykz9E9yeCZcUugpfiEThnR/view?usp=sharing',
        videoText: 'Emlak video link',
    },
    {
        id: '4',
        image: '/images/InistiSys.png',
        title : 'InstiSys ',
        technics: ['WPF', 'Sql Server DB', 'Entity Frameorkk'],
        description: 'A desktop application developed using C#.NET with a SQL Server database, designed to manage educational courses and their details. It facilitates student registration and enrollment in the appropriate courses, saves feerelated information, and allows users to inquire about all outstanding fees up to a speciﬁc date. The application also handles the calculation of income, expenses, and the deserved fees of individual students. Additionally, it maintains employee data and calculates their monthly salaries. ',
        url: '',
        urlText: '',
        video: 'https://drive.google.com/file/d/1Uc2k6l_-julyfKQ1VXa1y6B7MXu60kpK/view?usp=sharing',
        videoText: 'InstiSys video link',
    },
]

export default PROJECTS;